import { useState, useEffect, useRef, useCallback } from "react";
import { TIME_EXPIRATION_SECONDS } from "../utils/constants";

export const useTimer = (visualizadoEm) => {
  const [timeLeft, setTimeLeft] = useState(TIME_EXPIRATION_SECONDS);
  const [isExpired, setIsExpired] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    // Se não temos uma data de visualização, não fazemos nada.
    if (!visualizadoEm) {
      setTimeLeft(TIME_EXPIRATION_SECONDS); // Reseta para o valor inicial
      return;
    }

    // Calcula o tempo que já passou desde a confirmação
    const startTime = new Date(visualizadoEm).getTime();
    const now = Date.now();
    const elapsedSeconds = Math.round((now - startTime) / 1000);
    const initialTimeLeft = Math.max(
      0,
      TIME_EXPIRATION_SECONDS - elapsedSeconds
    );

    setTimeLeft(initialTimeLeft);

    // Lógica da contagem decrescente
    if (initialTimeLeft > 0) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timerRef.current);
            setIsExpired(true);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    } else {
      setIsExpired(true);
    }

    // Limpa o intervalo quando o componente é desmontado ou a data muda
    return () => clearInterval(timerRef.current);
  }, [visualizadoEm]); // Este efeito roda sempre que 'visualizadoEm' mudar

  return { timeLeft, isExpired, timerRef };
};
